module.exports = __webpack_public_path__ + "static/media/tablet.205582c2.png";